<template>
    <div>
        <v-btn icon target="_blank" @click="gamePDFLink(item)">
            <v-icon color="red">fa-file-pdf</v-icon>
        </v-btn>
    </div>
</template>

<script>
  import Vue from 'vue';

  export default {
    props: ["item"],
    methods: {
      gamePDFLink(item) {
        if (item.target) {
          var name = item.name
          var type = name.match(/^[A-za-z]{1,2}[0-9]/)[0].replace(/[0-9]$/, "").toLowerCase()
          var url = ""

          if (type == 'tt') url = `targettimes/${item.id}/pdf`;
          else url = `jumblewords/${item.id}/pdf`;

          Vue.prototype.$axios.get(url).then(async res => {
            var fileURL = res.data.fileURL;
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', `${res.data.fileName}.pdf`);
            document.body.appendChild(fileLink);
            fileLink.click();
          });

          return url;
        }
      }
    }
  }
</script>